import React from 'react';

const ICONS = {
	entered:
		'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
	assigned:
		'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',
	picking: 'M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14',
	completed: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0',
	overall: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
};

const LABELS = { entered: 'Entered', assigned: 'Assigned', picking: 'Picking', completed: 'Completed', overall: 'Overall' };

export default function StatusCard({ statusKey, value, active, onClick, percentage, loading }) {
	return (
		<div className={`status-card ${active ? 'status-card--active' : ''}`} onClick={onClick}>
			<div className="status-card__icon">
				<svg
					width="20"
					height="20"
					viewBox="0 0 24 24"
					fill="none"
					stroke={active ? '#fff' : '#2ec4a5'}
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<path d={ICONS[statusKey]} />
				</svg>
			</div>
			<div>
				<div className="status-card__label">{LABELS[statusKey]}</div>
				<div className="status-card__value">{loading ? '—' : value.toLocaleString()}</div>
				{percentage != null && (
					<div className="status-card__pct">{loading ? '' : `${percentage}% today`}</div>
				)}
			</div>
		</div>
	);
}
